import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryTransfers_ds_get_inventory_transfers_by_inventoryTransferIdsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { inventoryTransferIds: number[] }): 
  Promise<{ result: { Id?: number, InventoryTransferLines?: { Id?: number }[], Status?: { Id?: number, Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.inventoryTransferIds)) {
      missingRequiredInParams.push('\'inventoryTransferIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransfers/datasources/ds_get_inventory_transfers_by_inventoryTransferIds/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { inventoryTransferIds: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, InventoryTransferLines?: { Id?: number }[], Status?: { Id?: number, Name?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.inventoryTransferIds)) {
      missingRequiredInParams.push('\'inventoryTransferIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransfers/datasources/ds_get_inventory_transfers_by_inventoryTransferIds/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { inventoryTransferIds: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, InventoryTransferLines?: { Id?: number }[], Status?: { Id?: number, Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.inventoryTransferIds)) {
      missingRequiredInParams.push('\'inventoryTransferIds\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransfers/datasources/ds_get_inventory_transfers_by_inventoryTransferIds/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      inventoryTransferIds: number[]    }) {
        if(isNil(inParams.inventoryTransferIds)) {
          return true; 
        }
      return false;
    }
}
